import { render, staticRenderFns } from "./Echarts1.vue?vue&type=template&id=0aff7f60&"
import script from "./Echarts1.vue?vue&type=script&lang=js&"
export * from "./Echarts1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports